module.exports = __webpack_public_path__ + "img/CB919B_F9DDE1_ECC0C8_F4CCD4-256px.43cff845.png";